import type { IBraintree, IPayPal } from '@/types/PaymentGatewayTypes.ts'
import axios from 'axios'
import { ApiPost } from '@/api/Common.ts'
import type { AxiosError } from 'axios'
import { HidePayPalButtonPlaceholder } from '@/services/AoeHelpers.ts'

declare const braintree: IBraintree
declare const paypal: IPayPal

// Dedicated copy of AoeBraintreePaypalCheckout.ts for self-service RMA "add payment". See
// AoeBraintreeRma.ts for why this isn't shared with the checkout version (the checkout
// class hardcodes the cart identifier field name into its payment-submit payload).
class AoeBraintreePaypalCheckoutRma {
  clientToken = ''
  container = ''
  nonce = ''
  paypalScriptUrl = ''
  braintreeScriptUrl = ''
  createPaymentUrl = ''
  sourceValues = {
    systemKeyword: '',
    rmaNumber: '',
  }
  paymentValues = {
    paymentAmount: '',
    currencyCode: '',
  }
  Initialize() {
    console.log('RMA Braintree Paypal Checkout', 'Initialize')
    axios.get(this.paypalScriptUrl).then(() => {
      axios.get(this.braintreeScriptUrl).then(() => {
        this.InitializeDocumentReady()
      })
    })
  }
  InitializeDocumentReady() {
    braintree.client.create(
      {
        authorization: this.clientToken,
      },
      (clientErr, clientInstance) => {
        if (clientErr) {
          console.error(clientErr)
          return
        }

        braintree.paypalCheckout.create(
          {
            client: clientInstance,
          },
          (paypalCheckoutErr, paypalCheckoutInstance) => {
            if (paypalCheckoutErr) {
              console.error(paypalCheckoutErr)
              return
            }

            paypalCheckoutInstance.loadPayPalSDK(
              {
                currency: this.paymentValues.currencyCode,
                intent: 'capture',
              },
              () => {
                paypal
                  .Buttons({
                    fundingSource: paypal.FUNDING.PAYPAL,

                    createOrder: () => {
                      return paypalCheckoutInstance.createPayment({
                        flow: 'checkout',
                        amount: this.paymentValues.paymentAmount,
                        currency: this.paymentValues.currencyCode,
                        intent: 'capture',
                        enableShippingAddress: false,
                        shippingAddressEditable: false,
                      })
                    },

                    onApprove: (data: object) => {
                      return paypalCheckoutInstance.tokenizePayment(
                        data,
                        (err, payload) => {
                          if (err) {
                            console.error(err)
                            return
                          }

                          this.CreatePayment(payload)
                        },
                      )
                    },

                    onCancel: () => {
                      console.log('onCancel')
                    },

                    onError: (err: object) => {
                      console.error(err)
                    },
                  })
                  .render('#braintreepaypalbutton')
                  .then(() => {
                    HidePayPalButtonPlaceholder()
                  })
              },
            )
          },
        )
      },
    )
  }
  CreatePayment(payload: object) {
    console.debug('SavePayment', payload)
    const jsonDataToSave = {
      systemKeyword: this.sourceValues.systemKeyword,
      rmaNumber: this.sourceValues.rmaNumber,
      BraintreePayPalTokenizeResponse: {
        ...payload,
        clientToken: this.clientToken,
        flow: 'checkout',
      },
      charge: Number(this.paymentValues.paymentAmount),
    }
    if (this.createPaymentUrl && this.createPaymentUrl.length > 0) {
      ApiPost(this.createPaymentUrl, jsonDataToSave)
        .then((result: object) => {
          console.log('Processing complete', result)
          const successMessage = {
            messageType: 'aoepaymentcreated',
            messageData: result,
          }
          window.postMessage(successMessage)
        })
        .catch((errorResult: object) => {
          console.log('Processing error', errorResult)
          const axiosError = errorResult as AxiosError
          let messageData = null
          if (axiosError) {
            messageData = axiosError.response?.data
          }
          const errorMessage = {
            messageType: 'aoepaymentcreationerror',
            messageData: messageData,
          }
          window.postMessage(errorMessage)
        })
    } else {
      console.error('createPaymentUrl is empty')
    }
  }
}
export const aoeBraintreePaypalCheckoutRma = new AoeBraintreePaypalCheckoutRma()
